import { z } from 'zod'

export const userNotificationTypeSchema = z.enum([
  'WORKSPACE_INVITE',
  'PUBLIC_FORM_SUBMISSION',
  'FOLLOWUPS_DUE_SUMMARY',
  'AUTOMATION',
])

export const notificationSchema = z.object({
  id: z.string().uuid(),
  // Workspace the notification belongs to. For invites: the inviting workspace (not yet joined).
  workspaceId: z.string().uuid().nullable().optional(),
  type: userNotificationTypeSchema,
  title: z.string(),
  body: z.string(),
  // App-relative path opened when the notification is clicked (automation notifications)
  link: z.string().nullable().optional(),
  referenceId: z.string().uuid().nullable(),
  read: z.boolean(),
  createdAt: z.string(),
  // Phase 5: metadataCount for follow-ups due summary
  metadataCount: z.number().int().nullable().optional(),
})

// One page of the bell's view: the current workspace's notifications plus the user's invites.
export const notificationsListSchema = z.object({
  notifications: z.array(notificationSchema),
  // Unread in the whole view, not just this page.
  unreadCount: z.number().int().min(0),
  hasMore: z.boolean(),
})

// Cheap poll: unread counts for the bell's view and per workspace (invites excluded).
export const notificationSummarySchema = z.object({
  unreadCount: z.number().int().min(0),
  unreadByWorkspace: z.record(z.string().uuid(), z.number().int().min(0)),
})

export type UserNotificationType = z.infer<typeof userNotificationTypeSchema>
export type Notification = z.infer<typeof notificationSchema>
export type NotificationsList = z.infer<typeof notificationsListSchema>
export type NotificationSummary = z.infer<typeof notificationSummarySchema>
